<template>
	<div>
		<fieldset>
			<select-input
				title="Watertype"
				placeholder="Watertype"
				label="Wat is het watertype van jouw locatie?"
				name="type"
				:options="[
					'Sloot', 
					'Kanaal',
					'Kleine ondiepe plas',
					'Grote ondiepe plas',
					'Kleine diepe plas',
					'Grote diepe plas',
					'Beek',
					'Rivier ',
					'Weet niet',
				]"
				v-model="localMeasurement.watertype"
			/>

			<range-slider
				label="Welk rapportcijfer geef je het water?"
				:min="1"
				:max="10"
				:step="1"
				:default="1"
				v-model="localMeasurement.grade"
				subtitle="Geef het water een cijfer tussen 1 en 10, 1 is een hele slechte beleving en 10 een hele goede ervaring."
				name="grade"
			/>

			<multiple-choice 
				v-model="localMeasurement.reason"
				name="reason"
				:max="3"
				title="Toelichting rapportcijfer"
				subtitle="Geef hier maximaal 3 redenen als toelichting voor je rapportcijfer: Ik ga hier meten en geef dit rapportcijfer omdat..."
				:choices="reasons"
				otherValue="Andere reden, namelijk…"
			/>

			<select-input
				title="Geur"
				placeholder="Geur"
				label="Stinkt het water?"
				name="smell"
				subtitle="Het water kan bijvoorbeeld ruiken naar rotte eieren, riool, modder, vis, olie of iets anders, geef hieronder aan waar het naar ruikt."
				:options="smellOptions"
				v-model="localMeasurement.smell"
				other-value="Ja, het ruikt naar..."
				other-label="Geur"
			/>
		</fieldset>
		<nav>
			<button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
			<button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">
				Volgende
			</button>
		</nav>
	</div>
</template>

<script>
import SelectInput from './components/SelectInput.vue';
import RangeSlider from './components/RangeSlider.vue';
import MultipleChoice from './components/MultipleChoice.vue';
import FormStep from './FormStep.vue';
export default {
	name: 'FormStep3',
	components: { RangeSlider, SelectInput, MultipleChoice },
	mixins: [FormStep],
	data() {
		return {
			fieldRequirements: {
				watertype: ['required'],
				grade: ['required'],
				// reason: ['required'],
				smell: ['required'],
			},
			reasons: [
				{
					label: 'Ik hier in de buurt woon/hier vaak kom.',
				},
				{
					label: 'Ik in dit water zwem.',
				},
				{
					label: 'Ik in dit water vis.',
				},
				{
					label: 'Ik in dit water zeil, roei, kano of surf.',
				},
				{
					label: 'Ik me zorgen maak over de waterkwaliteit van dit water.',
				},
				{
					label: 'Ik me zorgen maak over de waterkwaliteit in Nederland.',
				},
				{
					label: 'Andere reden, namelijk…',
				},
			],
			smellOptions: [
				'Nee',
				'Ja, het ruikt naar...',
			],
		};
	},
};
</script>

<style scoped></style>
